module.exports = __webpack_public_path__ + "img/icon_zfb.465becf3.png";